export const FETCH_PAYOUTS = 'FETCH_PAYOUTS';
export const REQUEST_EARLY_PAYMENT = 'REQUEST_EARLY_PAYMENT';
export const REQUEST_REFUND_PAYMENT = 'REQUEST_REFUND_PAYMENT';
export const UPDATE_PAYOUT = 'UPDATE_PAYOUT';
export const ADD_PAYOUT = 'ADD_PAYOUT';
export const FETCH_PAYOUTS1 = 'FETCH_PAYOUTS1';
export const REPLACE_PAYOUT = 'REPLACE_PAYOUT';
